import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/src/stylus/app.styl'
import ru from 'vuetify/es5/locale/ru'
import theme from './themes/blueGrey.js'

Vue.use(Vuetify, {
  theme: theme,
  options: {
    customProperties: true
  },
  iconfont: 'mdi',
  lang: {
    locales: { ru },
    current: 'ru'
  }
})
